import React, { useMemo, useState } from "react";
import {
  Box,
  Flex,
  TableContainer,
  Table,
  Tbody,
  Td,
  Tr,
  Text,
  Th,
  Thead,
} from "@chakra-ui/react";
import { SearchInput } from "../../components/SearchInput";

export const DataTable = ({
  name = "",
  submittedAt = "",
  tableData = [],
  filterKeys = [],
  tableHeaders = [],
  type = "Individual",
}) => {
  const [searchText, setSearchText] = useState("");

  const onSearch = (e) => {
    setSearchText(e.target.value);
  };

  const filteredData = useMemo(
    () =>
      tableData?.filter((item) =>
        searchText !== ""
          ? Object.keys(item).find((key) =>
              item[key]
                ?.toString()
                ?.toLowerCase()
                ?.includes(searchText?.toLowerCase())
            )
          : 1
      ),
    [tableData, searchText]
  );

  return (
    <Box
      style={{
        width: "calc(100% - 300px)",
        padding: "30px 27px 0",
      }}
    >
      {type === "Individual" ? (
        <Flex
          style={{
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Text
              style={{
                fontSize: "20px",
                fontWeight: "600",
                fontFamily: '"Open Sans", sans-serif',
                color: "rgb(66, 71, 112)",
              }}
            >
              {name}
            </Text>
            <Text
              style={{
                fontSize: "14px",
                fontFamily: "Open Sans",
                color: "rgb(66, 71, 112)",
                opacity: "0.5",
              }}
            >
              {submittedAt}
            </Text>
          </Box>
          <SearchInput
            maxWidth="300px"
            value={searchText}
            placeholder="Search answers"
            onSearch={onSearch}
          />
        </Flex>
      ) : (
        <>
          <Flex
            style={{
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Text
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  fontFamily: '"Open Sans", sans-serif',
                  color: "rgb(66, 71, 112)",
                }}
              >
                Questions
              </Text>
            </Box>
            <SearchInput
              maxWidth="300px"
              value={searchText}
              placeholder="Search answers"
              onSearch={onSearch}
            />
          </Flex>
          <Box>
            <Text
              style={{
                fontSize: "12px",
                fontFamily: '"Open Sans", sans-serif',
                color: "rgb(66, 71, 112)",
                opacity: "0.5",
              }}
            >
              Question
            </Text>
            <Text
              style={{
                fontSize: "16px",
                fontWeight: "600",
                fontFamily: '"Open Sans", sans-serif',
                color: "rgb(66, 71, 112)",
              }}
            >
              {name}
            </Text>
          </Box>
        </>
      )}
      <TableContainer>
        <Table background="#fff" margin="20px 0">
          <Thead>
            <Tr>
              {React.Children.toArray(
                tableHeaders.map((thead) => <Th>{thead.title}</Th>)
              )}
            </Tr>
          </Thead>
          <Tbody>
            {React.Children.toArray(
              filteredData.map((rowData) => (
                <Tr>
                  {React.Children.toArray(
                    Object.keys(rowData)
                      .filter((keyItem) => filterKeys.includes(keyItem))
                      .map((key) =>
                        key === "comments" ? (
                          <Td>comment</Td>
                        ) : (
                          <Td
                            style={{
                              fontSize: "16px",
                              fontFamily: "Open Sans",
                              fontWeight: "400",
                              color: "rgb(66, 71, 112)",
                            }}
                          >
                            {rowData[key]}
                          </Td>
                        )
                      )
                  )}
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </TableContainer>
      {tableData.length === 0 && (
        <Text
          style={{
            fontSize: "16px",
            fontWeight: "600",
            fontFamily: '"Open Sans", sans-serif',
            color: "rgb(66, 71, 112)",
            textAlign: "center",
            padding: "20px",
          }}
        >
          No submission to show
        </Text>
      )}
    </Box>
  );
};
